import './RadioButton.scss';

function RadioButton({ checked, onChange, label, name, value, disabled = false, className = '', ...rest }) {
  return (
    <label className={`radio ${disabled ? 'radio--disabled' : ''} ${className}`}>
      <input
        type="radio"
        className="radio__input"
        name={name}
        value={value}
        checked={checked}
        onChange={(e) => !disabled && onChange?.(e.target.value)}
        disabled={disabled}
        {...rest}
      />
      <span className="radio__circle">
        <span className="radio__dot" />
      </span>
      {label && <span className="radio__label">{label}</span>}
    </label>
  );
}

function RadioGroup({ label, children, direction = 'vertical', className = '' }) {
  return (
    <div className={`radio-group ${direction === 'horizontal' ? 'radio-group--horizontal' : ''} ${className}`}>
      {label && <span className="radio-group__label">{label}</span>}
      {children}
    </div>
  );
}

RadioButton.Group = RadioGroup;

export default RadioButton;
